var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRingCentral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1560 338",
    width: 1560,
    height: 338,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ringcentral-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #ff7a00 } \r\n\t\t.s1 { fill: #0684bc } \r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1523.4 39.7h36.6v233.7h-36.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m1496.4 177.4v95.9h-34.7v-21.7h-1.6c-8.2 15.8-23.4 25.6-46.4 25.6-29.7 0-50.2-16.1-50.2-47 0-31 25.2-46.1 59.2-46.1h36.9v-7.9c0-17.4-8.8-28.4-28.1-28.4-16.5 0-25.9 7.5-28.4 20.2h-36c4.4-33.5 30.6-49.9 64.4-49.9 45.8 0 64.7 22.2 64.9 59.3zm-36.8 35.1l-0.2-2.1h-31.8c-17.1 0-26.5 6.9-26.5 20.2 0 11.6 8.8 18.5 23 18.5 22.3 0 35.5-13.6 35.5-36.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m1262.2 273.5v-151.6h34.4v21.4h1.3c7.9-14.8 20.5-21.4 37.8-21.4h14.9v34.7h-14.4c-23 0-37.6 14.8-37.6 38.2v78.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m1239 240v33.4h-25c-35 0-54.3-16.2-54.3-51.3v-70.2h-24.9v-30h24.9v-40.3h36.7v40.3h42.6v30h-42.6v66c0 13.9 8.2 22.1 22.1 22.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m978.3 273.5v-151.6h34.3v20.8h1.3c7.9-14.2 25.6-24.6 48.6-24.6 38 0 56.5 23 56.5 61.2v94.1h-36.6v-88.2c0-23.2-12.3-35.1-32.9-35.1-21.4 0-34.7 14.1-34.7 35.6v87.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m915 227.5h35.5c-7.3 29.7-32.2 49.9-70.4 49.9-45.6 0-75-31-75-79.6 0-48.6 31.7-79.6 75-79.6 40.1 0 72.9 26.6 72.9 77.4l0.2 11.8h-112.1c0.6 24.4 16.1 39.8 39.1 39.8 21.2 0 30.8-8.3 34.8-19.7zm-74-46.4h78.2c-0.9-19-15.1-32.6-39.1-32.6-24 0-35.7 13.3-39.1 32.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m695.6 277.8c-60.6 0-104.5-42.3-104.5-114.6 0-72.2 43.9-114.5 104.5-114.5 56.3 0 86.8 29.3 92.8 74.3h-37.1c-4.9-20.2-19.4-39.2-55.7-39.2-36.3 0-65.4 24.7-65.4 78.9 0 54.2 29.1 79 65.4 79 35.2 0 50.1-18.9 55.7-39.5h37.1c-7.3 45-38.2 75.3-92.8 75.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m566.5 121.9v155.7c0 37.3-21.7 60.1-62.5 60.1h-73.5v-32.7h74.3c15.4 0 24.9-7.9 24.9-24.9v-32h-1.7c-10.5 16.1-24.3 25.6-47.7 25.6-35.9 0-67.5-28.4-67.5-78 0-49.5 32-77.6 67.5-77.6 24.3 0 41.4 10 49.6 24.6h1.7v-20.8zm-36.7 73.9c0-29.7-15.8-44.9-39.5-44.9-24.4 0-39.7 15.2-39.7 44.9 0 29.7 15.4 44.8 39.7 44.8 23.9 0 39.5-15.1 39.5-44.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m249.7 273.5v-151.6h34.2v20.8h1.3c7.9-14.2 25.7-24.6 48.8-24.6 37.9 0 56.5 23 56.5 61.2v94.1h-36.6v-88.2c0-23.2-12.4-35.1-32.9-35.1-21.4 0-34.7 14.1-34.7 35.6v87.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m182.1 121.9h36.6v151.5h-36.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m154.7 217.9v55.7h-37.9v-55.7q0-32.2-32.2-32.2h-46.1v87.7h-37.9v-221h81.5c47.9 0 73.8 25.3 73.8 60 0 33.8-15.1 48.8-37.5 55v1.5c23 5.1 36.3 17.7 36.3 49zm-38.4-98.8c0-24-15.8-32.6-36.3-32.6h-41.5v65h41.5c20.4 0 36.3-8.4 36.3-32.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m191.1 95.7c-4.4-1.8-8.3-4.9-10.9-8.9-2.7-4-4.1-8.7-4.1-13.6 0-4.8 1.5-9.5 4.1-13.5 2.7-4 6.5-7.1 10.9-9 4.5-1.8 9.4-2.3 14.1-1.4 4.7 1 9.1 3.3 12.5 6.7 3.4 3.4 5.7 7.7 6.6 12.5 1 4.7 0.5 9.6-1.4 14-1.8 4.5-4.9 8.3-8.9 10.9-4 2.7-8.8 4.1-13.6 4.1-3.2 0.1-6.3-0.5-9.3-1.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m214.6 1.7c14.1 2.8 27.1 9.7 37.3 19.9l-17.2 17.2c-4.5-4.6-9.9-8.1-15.8-10.5-5.9-2.5-12.2-3.7-18.6-3.7-6.4 0-12.7 1.3-18.6 3.8-5.9 2.4-11.2 6-15.7 10.5l-17.2-17.1c6.8-6.9 14.9-12.3 23.7-16 13.3-5.5 28-6.9 42.1-4.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingCentral);
export default __webpack_public_path__ + "static/media/RingCentral.4fff7088c05a5e2133a0536e9343f877.svg";
export { ForwardRef as ReactComponent };